import React, { useState } from "react";
import {
  FaAndroid,
  FaDesktop,
  FaGlobe,
  FaMobileAlt,
  FaShoppingCart,
  FaUser,
  FaUserPlus,
  FaUserTie,
} from "react-icons/fa";
import AddUsers from "../../../assets/Docs/AddUsers.png";
import viewUsers from "../../../assets/Docs/ViewUsers.png";
import { TagComponent } from "../Tabs";
import { TbShieldCheck } from "react-icons/tb";
import { FiSend } from "react-icons/fi";

const Users = () => {
  const [activeTab1, setActiveTab1] = useState("web");

  const tabs = [
    { id: "web", label: "Web App", icon: <FaDesktop /> },
    {
      id: "mobile",
      label: "Mobile App",
      icon: <FaMobileAlt />,
      disabled: true,
    },
  ];

  
  const renderTabs = (activeState, setActiveState) => (
    <div className="flex flex-col sm:flex-row gap-2 border-b border-[#b9ece6] sm:gap-4 mb-6">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => !tab.disabled && setActiveState(tab.id)}
          className={`flex items-center justify-center sm:justify-start gap-2 px-4 py-2 rounded-t-md transition-all text-sm w-full sm:w-auto ${activeState === tab.id
            ? "bg-[#1a9588] text-white shadow"
            : "bg-[#dbf4f1] text-gray-700 hover:bg-[#b9ece6]"
            } ${tab.disabled ? "opacity-50 cursor-not-allowed hover:bg-[#dbf4f1]" : ""}`}
          disabled={tab.disabled}
        >
          {tab.icon}
          {tab.label}
        </button>
      ))}
    </div>
  );

  return (
    <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8  mx-auto border border-gray-200" id="top">


      <div className="flex items-center mb-6 border-b pb-4 border-gray-200">
        <FaUser className="text-4xl text-theme-logo-color mr-3" />
        <h1 className="text-2xl sm:text-3xl font-bold text-theme-logo-color">Users</h1>
      </div>

      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaUserTie />} label="Seller" color="green" />
          <TagComponent icon={<FaShoppingCart />} label="Buyer" color="pink" />
        </div>
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaGlobe />} label="Web" color="green" />
          <TagComponent icon={<FaAndroid />} label="Android" color="green" />
        </div>
      </div>


      <div className="  bg-white p-6 rounded shadow">
        <div className="bg-white p-8 rounded-2xl shadow-lg text-start max-w-6xl mx-auto">
          {/* Intro */}
          <p className="text-gray-600 mb-6 leading-relaxed">
            Every user in <span className="font-semibold text-indigo-600">Selzor</span>
            has a set of privileges, that can be set by going to the
            <span className="font-medium"> "User" </span> section.
          </p>

          {/* Adding / Updating Users */}
          <h2 className="text-xl font-bold text-gray-800 mb-3 flex items-center gap-2">
            <FaUserPlus className="w-6 h-6 text-indigo-600" />
            Adding / Updating Users
          </h2>
          <p className="text-gray-400 mb-6 leading-relaxed">
            All connections in Selzor work on an invitation basis. Before adding a
            user, ensure they have registered on Selzor. If they haven’t, ask them
            to sign up and verify their mobile number or email address. Only after
            that can you send them an invitation to join your{" "}
            <span className="font-medium text-indigo-600">Seller</span> or{" "}
            <span className="font-medium text-indigo-600">Buyer</span> account.
          </p>

          {/* Steps */}
          <p className="text-gray-700 font-medium mb-3">Steps to add a user:</p>
          <ul className="space-y-3 mb-6">
            <li className="flex items-start gap-3 bg-gray-50 p-3 rounded-lg border border-gray-100 shadow-sm">
              <TbShieldCheck className="w-5 h-5 text-green-600 mt-1" />
              <span>Find a registered Selzor user using their mobile number or email address.</span>
            </li>
            <li className="flex items-start gap-3 bg-gray-50 p-3 rounded-lg border border-gray-100 shadow-sm">
              <TbShieldCheck className="w-5 h-5 text-green-600 mt-1" />
              <span>Select User Type & Set Privileges</span>
            </li>
            <li className="flex items-start gap-3 bg-gray-50 p-3 rounded-lg border border-gray-100 shadow-sm">
              <FiSend className="w-5 h-5 text-blue-600 mt-1" />
              <span>Send Request</span>
            </li>
          </ul>

          {/* Final Note */}
          <p className="text-gray-600 leading-relaxed">
            After the invited user accepts your request, they will be added to your{" "}
            <span className="font-medium text-indigo-600">Seller</span> or{" "}
            <span className="font-medium text-indigo-600">Buyer</span> account and
            will be able to perform all actions based on the privileges assigned.
          </p>
        </div>
        <div className="my-5">
          {/* Heading for Add User */}
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-500 mb-4 text-start">
            Add User
          </h2>

          {renderTabs(activeTab1, setActiveTab1)}
          <div className="rounded-lg p-2 sm:p-4 flex justify-start">
            <img
              src={AddUsers}
              alt={`${activeTab1} view`}
              className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
            />
          </div>
        </div>

        <div className="my-5">
          {/* Heading for View User */}
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-500 mb-4 text-start">
            View User
          </h2>

          {renderTabs(activeTab1, setActiveTab1)}
          <div className="rounded-lg p-2 sm:p-4 flex justify-start">
            <img
              src={viewUsers}
              alt={`${activeTab1} view`}
              className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Users;
